import React, { FC } from "react";
import { ChakraProvider } from "@chakra-ui/react";
import {
  gregAdminTheme,
  PaginatedGrid,
} from "@getregistered/greg-editors";

import { downloadActionLink } from "../../domain/grid/downloadActionLink";

export interface DownloadLink {
  title: string;
  baseUrl: string;
}

type Props = React.ComponentProps<typeof PaginatedGrid> & { downloadLinks?: DownloadLink[] };

export const PaginatedApplicationGrid: FC<Props> = (props) => (
  <ChakraProvider theme={gregAdminTheme} resetCSS={false}>
    <PaginatedGrid
      {...props}
      actionLinks={props.downloadLinks?.map(({ title, baseUrl }) =>
        downloadActionLink(title, baseUrl)
      )}
    />
  </ChakraProvider>
);
